import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Paper from '@material-ui/core/Paper';

type Props = {
  title: string,
  children: React.ReactNode
};

const HeadedContent: React.FC<Props> = ({title, children}) => {
  return <Paper>
    <h2 style={{padding: '15px'}}>{title}</h2>
    {children}
  </Paper>;
};
export default HeadedContent;
